<template>
  <div class="download-file" @click="downloadFile">
    <slot v-if="isIE"></slot>
    <a v-else :href="downloadLink" class="download-file--a" download="">
      <slot></slot>
    </a>
  </div>
</template>

<script>
export default {
  name: 'DownloadFile',

  props: {
    downloadLink: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isIE: false,
      host: process.env.VUE_APP_DOMAIN
    }
  },

  mounted() {
    this.browserJudgement()
  },

  methods: {
    // 判断浏览器
    browserJudgement() {
      const userAgent = navigator.userAgent
      const isLowIE =
        userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
      const isIE11 =
        userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
      this.isIE = isIE11 || isLowIE
    },

    downloadFile() {
      if (this.isIE) {
        const host = process.env.VUE_APP_DOMAIN
        const url =
          this.downloadLink.indexOf(host) > -1
            ? this.downloadLink
            : `${host}${this.downloadLink}`
        window.open(url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.download-file {
  display: inline-block;
  cursor: pointer;

  &:hover {
    color: $primary-color;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
}
</style>
